import { PermissionSetGroupingKey } from '../PermissionSetTypes'
import { PermissionType } from '../PermissionType'

export enum EamMeterEntryPermissionSet {
  View = 'eam_meter_entry_view',
  Write = 'eam_meter_entry_write',
}

export const EamMeterEntryPermissions = {
  [EamMeterEntryPermissionSet.View]: [PermissionType.GET_ANY_EAM_METER_ENTRY],
  [EamMeterEntryPermissionSet.Write]: [PermissionType.WRITE_ANY_EAM_METER_ENTRY],
}

export const eamMeterEntryPermissionSetGrouping = {
  key: PermissionSetGroupingKey.EamMeterEntry,
  active: EamMeterEntryPermissions,
  unAssignablePermissionSets: [],
}
